<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let { index, featureIndex, removeSkeleton, errorCallback, performance, pageType, cinemaInjectionContainerWidth } =
        $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        var apiURL = "/reco-core/recommendations/lastseen/";
        if (pageType) {
            apiURL += `?pageType=${pageType}`;
        }
        const res = await ajaxFetch(apiURL);
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <Cinema
        {headline}
        {recommendations}
        {tracking}
        {featureIndex}
        {additionalClickTracking}
        {featuresState}
        {cinemaInjectionContainerWidth}
        cinemaIndex={index}
        cinemaMeta={metaData}
        {performance}
        site="reco_lastSeenArticles"
        personalisedUser={hasPersonalisedRecommendations}
    />
{/if}
